import { Component, OnInit } from '@angular/core';
import { CONSTANTS } from '../../constants';
import { DataService } from '../../services/data.service';
import { AccountService } from '../../services/api/account.service';
import { OrderService } from '../../services/api/order.service';
import { PositionService } from '../../services/api/position.service';
import { NotificationService } from '../../services/notification.service';
import { JqueryUtils } from '../../utils/jquery.utils';

@Component({
  selector: 'app-order-positions',
  templateUrl: './order-positions.component.html',
  styleUrls: ['./order-positions.component.scss']
})
export class OrderPositionsComponent implements OnInit {

  admin: any;

  users: any = [];
  orders: any = [];
  positions: any = [];
  filter_params: any = { user_id: '' };
  tabInfo: any;
  emsg = "";
  cancelParams: any = { msg: '' };

  constructor(private accountService: AccountService, private dataService: DataService,
    private orderService: OrderService, private positionService: PositionService, private jq: JqueryUtils,
    private ns: NotificationService) { }

  ngOnInit(): void {
    this.admin = (sessionStorage.getItem(CONSTANTS.COOKIE.IS_ADMIN) == 'true');
    this.dataService.pageLoaded({name: CONSTANTS.URI_PATH.ORDER_POS});
    this.tabInfo = {
      'selected': 'orders',
      'ordersCls': { 'show': 1, 'active': 1},
      'positionsCls': { 'show': 0, 'active': 0}
    }
    this.listUsers();
  }

  listUsers() {
    this.accountService.listAccounts().subscribe((response: any) => {
      if (response.response_code == 1000) {
        let users = []
        for (let i = 0; i < response.accounts.length; i++) {
          let acc = response.accounts[i]
          users.push({
            _id: acc._id,
            full_name: acc.user.full_name,
          })
        }
        this.users = users;
        this.filter_params.user_id = this.users[0]._id;
      }
    });
  }

  loadOrderPositions() {
    let user: any = this.getUserById(this.filter_params.user_id);
    if (!user) {
      this.ns.showAlert(CONSTANTS.ERROR, "Please select user.");
      return;
    }
    let ip: any = {
      user_id: user._id
    };
    if (this.tabInfo.selected == 'orders') {
      this.orderService.getOrders(ip).subscribe((response: any) => {
        let orders: any = [];
        if (response.data[0].emsg == "") {
          let order;
          let res = response.data;
          for (let idx = 0; idx < res.length; idx++) {
            for (let i = 0; i < res[idx].orders.length; i++) {
              order = res[idx].orders[i]
              orders.push({
                bacc_id: order.bacc._id,
                time: order.completed_time || order.entry_time,
                trading_symbol: order.trading_symbol,
                transaction_type: order.transaction_type,
                qty_filled: `${order.filled_qty}/${order.qty}`,
                product_type: order.product_type,
                price_trg_price: `${order.price}/${order.trigger_price}`,
                average_price: order.average_price,
                exchange: order.exchange,
                token: order.token,
                status: order.status,
              })
            }
          }
          this.emsg = "";
        } else {
          this.emsg = response.data[0].emsg;
        }
        this.orders = orders;
      });
    } else {
      this.positionService.getPositions(ip).subscribe((response: any) => {
        let positions: any = [];
        if (response.data[0].emsg == "") {
          let position, total = 0.0;
          let res = response.data;
          for (let idx = 0; idx < res.length; idx++) {
            for (let i = 0; i < res[idx].positions.length; i++) {
              position = res[idx].positions[i]
              positions.push({
                bacc_id: position.bacc._id,
                product_type: position.product_type,
                trading_symbol: position.trading_symbol,
                qty: position.qty,
                exchange: position.exchange,
                token: position.token,
                buy_avg_price: position.buy_avg_price,
                sell_avg_price: position.sell_avg_price,
                pnl: position.pnl,
                show_close: true
              })
              total += parseFloat(position.pnl.replace(",", ""));
            }
          }
          positions.push({
            sell_avg_price: 'Total',
            pnl: total,
            show_close: false
          })
          this.emsg = "";
        } else {
          this.emsg = response.data[0].emsg;
        }
        this.positions = positions;
      });
    }
  }

  onUserChanged() {
    this.orders = [];
    this.positions = [];
    this.emsg = "";
  }

  onTabSelected(selected_tab: any) {
    this.tabInfo.selected = selected_tab;
    this.tabInfo.ordersCls = { 'show': (selected_tab == 'orders') ? 1 : 0, 'active': (selected_tab == 'orders') ? 1 : 0 }
    this.tabInfo.positionsCls = { 'show': (selected_tab == 'positions') ? 1 : 0, 'active': (selected_tab == 'positions') ? 1 : 0 }
    this.emsg = "";
  }

  getUserById(user_id: any) {
    let user;
    for (let idx = 0; idx < this.users.length; idx++) {
      if (this.users[idx]._id == user_id) {
        user = this.users[idx];
        break;
      }
    }
    return user;
  }

  showCancelConfirmation(on: any, data: any) {
    if (on == 'order') {
      this.cancelParams = { msg: 'Are you sure want to cancel the order?' };
    } else if (on == 'position') {
      this.cancelParams = { msg: 'Are you sure want to close the position?' };
    }
    this.cancelParams.on = on;
    this.cancelParams.data = data;
    this.jq.openModal('cancelOPConfirmationModal');
  }

  cancelOrderPosition(params: any) {
    let user: any = this.getUserById(this.filter_params.user_id);
    if (!user) {
      this.ns.showAlert(CONSTANTS.ERROR, "Please select user.");
      return;
    }
    if (params.on == 'order') {
      this.orderService.cancelOrder({user_id: user._id, bacc_id: params.data.bacc_id}, params.data).subscribe((response: any) => {
        this.ns.showAlert(CONSTANTS.SUCCESS, "Order cancelled successfully.");
        this.jq.closeModal('cancelOPConfirmationModal');
      });
    } else if (params.on == 'position') {
      this.positionService.closePosition({user_id: user._id, bacc_id: params.data.bacc_id}, params.data).subscribe((response: any) => {
        this.ns.showAlert(CONSTANTS.SUCCESS, "Position closed successfully.");
        this.jq.closeModal('cancelOPConfirmationModal');
      });
    }
  }

  closeCancelConfirmation() {
    this.jq.closeModal('cancelOPConfirmationModal');
  }
}
